import { createAppAsyncThunk } from '../create-app-thunk';

export const getBlogMenu = createAppAsyncThunk(
  'blog/getMenu',
  async (_, { getState, rejectWithValue, extra: { blogMenuService } }) => {
    try {
      const storeId = getState()?.root?.storeConf?.storeId;
      return await blogMenuService.getMenu(storeId);
    } catch (error) {
      return rejectWithValue([]);
    }
  },
);
